var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightAndHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.382,
    height: 20,
    viewBox: "0 0 33.382 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195",
    transform: "translate(17707 -1604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blue_hotel",
    "data-name": "blue hotel",
    transform: "translate(-17707 1604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M660.77,1329.974v0C660.77,1329.963,660.77,1329.965,660.77,1329.974Zm3.408,18.566v-14.67a.721.721,0,0,0-.631-.786h-2.79c.007-1.787.012-3.012.013-3.11a.712.712,0,0,0-.6-.786h-8.336a.713.713,0,0,0-.6.788v18.564H650v.647h15.422v-.647Zm-10.255-7.523c0,.436-.266.789-.6.789a.713.713,0,0,1-.6-.789v-.788a.713.713,0,0,1,.6-.789c.329,0,.6.353.6.789Zm0-3.943a.619.619,0,1,1-1.191,0v-.789a.619.619,0,1,1,1.191,0Zm0-3.943a.619.619,0,1,1-1.191,0v-.788a.713.713,0,0,1,.6-.789c.329,0,.6.353.6.789Zm2.679,7.887a.713.713,0,0,1-.6.789c-.329,0-.6-.353-.6-.789v-.788c0-.436.266-.789.6-.789s.6.353.6.789Zm0-3.943a.619.619,0,1,1-1.191,0v-.789a.619.619,0,1,1,1.191,0Zm0-3.943a.619.619,0,1,1-1.191,0v-.788c0-.436.266-.789.6-.789a.713.713,0,0,1,.6.789Zm2.679,7.887a.713.713,0,0,1-.6.789c-.329,0-.6-.353-.6-.789v-.788c0-.436.266-.789.6-.789s.6.353.6.789Zm0-3.943a.619.619,0,1,1-1.191,0v-.789a.619.619,0,1,1,1.191,0Zm0-3.943a.619.619,0,1,1-1.191,0v-.788c0-.436.266-.789.6-.789a.713.713,0,0,1,.6.789Zm3.634,11.736a.646.646,0,1,1-1.262,0v-.785a.646.646,0,1,1,1.262,0Zm0-3.534a.646.646,0,1,1-1.262,0v-.786a.646.646,0,1,1,1.262,0Zm0-3.535a.646.646,0,1,1-1.262,0v-.786a.646.646,0,1,1,1.262,0Z",
    transform: "translate(-650 -1329.188)",
    fill: "#25ac03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_airplanemode_active_24px",
    transform: "translate(-17690.891 1604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M10.18,9",
    transform: "translate(-2.744 -2)",
    fill: "#25ac03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M19.272,16V14L12,9V3.5A1.435,1.435,0,0,0,10.636,2,1.435,1.435,0,0,0,9.273,3.5V9L2,14v2l7.273-2.5V19L7.454,20.5V22l3.182-1,3.182,1V20.5L12,19V13.5Z",
    transform: "translate(-2 -2)",
    fill: "#25ac03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightAndHotel);
export default __webpack_public_path__ + "static/media/flightAndHotel.7b63482a72bede94852abd085fca06d7.svg";
export { ForwardRef as ReactComponent };